/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";

interface PassportPanelProps {
  title: string;
  children: React.ReactNode;
}

const PassportInfoPanel: FC<PassportPanelProps> = ({ title, children }) => (
  <div className="col-md-6">
    <div className="card">
      <div className="card-header" style={{ marginBottom: "30px" }}>
        <a className="card-title">{title}</a>
      </div>
      <div className="col-md-6">
        <div className="row">{children}</div>
      </div>
    </div>
  </div>
);

export default PassportInfoPanel;
